
import styled, { css } from 'styled-components';

const AlphaLogo = () => css`
    position:absolute;
    float:right;
    top:5%;
    right:4%;
    z-index:1321;
    display: ${({ show }) => (show ? 'flex' : 'none')};

`;


export default styled.div([AlphaLogo]);